import React, { FC, useMemo, useState } from 'react'

import { useParams } from 'react-router'

import InfiniteScrollDataTable from '../../../../../../components/common/tables/InfiniteScrollDataTable'

import { getColumnsScoring } from './data/columns'
import { useEventRiderTeamMembers } from '../../../../../../hooks/useEventRiderTeamMembers'
import { getAllRegistrationFees } from '../../../../../../helpers/registrationFees'
import { getRidersByRideTimeByClass } from '../OrderOfGoTable/data/order-of-go-rider-utils'

import {
  IEventFees,
  RegistrationFeesType,
} from '../../../../../../models/event-fees/event-fees.interface'
import { IRegistrationByDayInterface } from '../../../../../../models/registrations-by-day/registrationByDay.interface'
import { IRegistrationByDayEx } from '../../ManageClinicNOtherOperationsTab'
import { IBreak } from '../../../../../../models/events/event.interface'
import { sortByOrder } from '../../data/operations-tab-utils'

interface ScoringTableByClassProps {
  registrationsByDayByClass: IRegistrationByDayInterface[]
  increment: string
  registrationsByDay: IRegistrationByDayInterface[]
  breaks: IBreak[]
  setRegistrationsByDay: (value: IRegistrationByDayInterface[]) => void
  registrationFees: IEventFees | null
  onScore: (value: IRegistrationByDayEx) => Promise<void>
  fileChangedHandler: (row: IRegistrationByDayEx, file: FileList | null) => Promise<void>
}

export const ScoringTableByClass: FC<ScoringTableByClassProps> = ({
  registrationsByDayByClass,
  breaks,
  increment,
  setRegistrationsByDay,
  registrationsByDay,
  registrationFees,
  onScore,
  fileChangedHandler,
}) => {
  const { eventId } = useParams<{ eventId: string }>()
  const { eventTeamMembers, eventTeamMembersLoading } = useEventRiderTeamMembers(eventId)

  const [scoringLoading, setScoringLoading] = useState('')
  const [uploadLoading, setUploadScoringLoading] = useState('')

  const registrationsToDisplay = useMemo(() => {
    return sortByOrder([...registrationsByDayByClass])
  }, [registrationsByDayByClass])

  const getTime = (row: IRegistrationByDayInterface) => {
    const flattenedFees = getAllRegistrationFees(registrationFees?.registrationFees || [])
    // Find the fee whose UUID matches the registration's UUID
    const matchingFee = flattenedFees?.find(
      (feeItem: RegistrationFeesType) => feeItem.uuid === row.uuid
    )

    if (increment && matchingFee) {
      const ridersByRideTimeByClass = getRidersByRideTimeByClass(
        [
          ...registrationsByDayByClass,
          ...breaks?.filter((item) => item.registrationByDayUuid === matchingFee.uuid),
        ],
        matchingFee,
        increment
      )
      const current = ridersByRideTimeByClass.find((item) => item.id === row.id)
      return current?.rideTimeScheduleByClass || '00:00:00 AM'
    } else {
      return '00:00:00 AM'
    }
  }

  return (
    <div className="relative">
      <InfiniteScrollDataTable
        hasMore={false}
        className="exhibitorListTable"
        columns={getColumnsScoring({
          type: 'class',
          eventTeamMembers,
          eventTeamMembersLoading,
          registrationsByDay,
          setRegistrationsByDay,
          scoringLoading,
          uploadLoading,
          getTime,
          registrationFees,
          onScore: async (value) => {
            setScoringLoading(value.id || '')
            await onScore(value)
            setScoringLoading('')
          },
          fileChangedHandler: async (row, file) => {
            setUploadScoringLoading(row.id || '')
            await fileChangedHandler(row, file)
            setUploadScoringLoading('')
          },
        })}
        data={registrationsToDisplay}
      />
    </div>
  )
}
